import { useGetGatePassHistory, useGetServiceRequestGatePassId } from "../helpers"

import moment from "moment"
import { useServiceRequestContext } from "../service-request"

export const GatePassHistory = () => {
    const { result } = useServiceRequestContext()
    const { serviceRequest } = result || {}
    const { gatePassId } = useGetServiceRequestGatePassId(serviceRequest)
    const { data } = useGetGatePassHistory(gatePassId)

    const validData = data.filter(item => item.createdOn);
    const sortedData = [...validData].sort((a, b) => new Date(a.createdOn!).getTime() - new Date(b.createdOn!).getTime());

    if (!gatePassId || data.length === 0)
        return <></>

    return <div className="card card-body">
        <div className="d-flex align-items-center justify-content-center">
            <div className="card-header min-h-5px border-0">
                <h6 className="my-3">Gate Pass History</h6>
            </div>
        </div>
        <div className="row mt-3">
            <div className="col-12">
                <div className='timeline-label' style={{ width: '100%' }}>
                    {sortedData.map((item, i) => (
                        <div className='timeline-item d-flex' style={{ width: '100%' }} key={i}>
                            <div className='timeline-label fw-bold text-gray-800 fs-7'>
                                <div className="text-end pe-3">
                                  <p className="my-0 fw-bolder">{moment(item.createdOn).format('DD-MM-YYYY HH:mm')}</p>
                                </div>
                            </div>
                            <div className='timeline-badge'>
                                <i className='fa fa-genderless text-primary fs-1'></i>
                            </div>
                            <div className='timeline-content ps-3' style={{ width: '100%' }}>
                                <p>{item.name}</p>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </div>
    </div>
}
